import { useMemo, useState } from 'react';
import type { CheckItemResult } from '@shared/types';
import { CATEGORY_LABELS } from '@shared/types';
import { STATUS_META, itemSortKey } from '../scoreUtils';

interface Props {
  items: CheckItemResult[];
}

/** 課題リスト。fail>warn>pass>na 順、critical を赤バッジ、advice を表示 */
export default function IssueList({ items }: Props) {
  const [hidePass, setHidePass] = useState(true);

  const sorted = useMemo(() => {
    return [...items].sort(
      (a, b) =>
        itemSortKey(a.status, a.critical) - itemSortKey(b.status, b.critical),
    );
  }, [items]);

  const visible = hidePass
    ? sorted.filter((i) => i.status === 'fail' || i.status === 'warn')
    : sorted;

  const failCount = items.filter((i) => i.status === 'fail').length;
  const warnCount = items.filter((i) => i.status === 'warn').length;

  return (
    <div className="issue-list">
      <div className="issue-list__head">
        <div className="issue-list__summary">
          <span className="issue-list__count issue-list__count--fail">
            NG {failCount}
          </span>
          <span className="issue-list__count issue-list__count--warn">
            注意 {warnCount}
          </span>
        </div>
        <label className="issue-list__toggle">
          <input
            type="checkbox"
            checked={hidePass}
            onChange={(e) => setHidePass(e.target.checked)}
          />
          課題のみ表示
        </label>
      </div>

      {visible.length === 0 ? (
        <p className="issue-list__empty">表示する項目はありません。</p>
      ) : (
        <ul className="issue-list__items">
          {visible.map((item) => {
            const meta = STATUS_META[item.status];
            return (
              <li key={item.key} className="issue-item">
                <div className="issue-item__row">
                  <span
                    className="issue-item__status"
                    style={{ backgroundColor: meta.color }}
                  >
                    {meta.label}
                  </span>
                  <span className="issue-item__label">{item.label}</span>
                  {item.critical && (
                    <span className="issue-item__critical">重要</span>
                  )}
                  <span className="issue-item__cat">
                    {CATEGORY_LABELS[item.category]}
                  </span>
                </div>
                {item.advice && (item.status === 'fail' || item.status === 'warn') && (
                  <p className="issue-item__advice">{item.advice}</p>
                )}
                {item.evidence && Object.keys(item.evidence).length > 0 && (
                  <details className="issue-item__evidence">
                    <summary>根拠データ</summary>
                    <pre>{JSON.stringify(item.evidence, null, 2)}</pre>
                  </details>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
